import { FormEvent, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, InputBar } from '~/ui';
import styles from './FolderCreateForm.module.scss';

interface IFormProps {
  onSubmit: (value: string) => void;
  onClick: () => void;
}

export const FolderCreateForm = ({ onSubmit, onClick }: IFormProps) => {
  const { t } = useTranslation();
  const [folderName, setFolderName] = useState('');

  const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    onSubmit(folderName);
    setFolderName('');
  };

  return (
    <div className={styles.formWrapper}>
      <p className={styles.title}>{t('new_folder')}</p>
      <form className={styles.form} onSubmit={handleSubmit}>
        <InputBar
          label={t('name_secondary')}
          name="folder_name"
          value={folderName}
          placeholder={t('folder_name')}
          onChange={e => setFolderName(e.target.value)}
        />
        <div className={styles.btnWrapper}>
          <Button
            type="button"
            text={t('close')}
            className={styles.closeBtn}
            onClick={onClick}
          />
          <Button
            type="submit"
            text={t('create')}
            className={styles.createBtn}
          />
        </div>
      </form>
    </div>
  );
};
